
require.register("lodash-compat/internal/arrayPush.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "lodash-compat");
  (function() {
    /**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;
  })();
});